<section class="plan-compare">
  <header class="plan-compare__header">
    <h6 class="t-bold" data-test-id="planCompareHeader">{{ compareTitle }}</h6>
  </header>

  @if (comparedPlans.length === 0) {
    <div class="plan-compare__plan">
      <p class="t-data" data-test-id="planCompareMsg">{{ compareMessage }}</p>
    </div>
  } @else {
    @for (plan of comparedPlans; track plan; let i = $index) {
      <div class="plan-compare__plan plan-compare__plan--chip">
        <p class="t-data t-bold" [data-test-id]="'planDisplayName_' + i">
          {{ plan.display_name }}
        </p>
        @if (!isPlanLocked(plan)) {
          <zip-button
            [config]="{
              level: 'text',
              icon: 'close',
            }"
            (zipButtonClicked)="removePlanFromComparison(plan)"
            data-test-id="closeButton"
          >
          </zip-button>
        }
      </div>
    }
    @for (
      placeholder of placeholders | slice: comparedPlans.length;
      track placeholder
    ) {
      <div class="plan-compare__plan plan-compare__plan--empty">
        <p class="t-data" [data-test-id]="comparePlaceholder">
          {{ comparePlaceholder }}
        </p>
      </div>
    }
  }

  @if (comparedPlans.length > 1) {
    <zip-button
      [config]="compareButtonConfig"
      (zipButtonClicked)="showCompareTable()"
      data-test-id="comparePlanButton"
    ></zip-button>
  }
</section>
